'use client';
import React from 'react';
import PropTypes from 'prop-types';
import {
  NullErrorBoundary,
  BuildPropsError,
  MissingCMSComponent,
} from './errors';

const componentToElement = content => {
  // Lazy require breaks the circular dependency:
  // CMSBlok -> builders -> rich_text -> RichText -> CMSBlok
  // Safe because this only runs at render time when all modules are initialized.
  const builders = require('./builders');
  const builder = builders[content.component];
  if (!builder) {
    return <MissingCMSComponent type={content.component} />;
  }

  const { component: Component, schema } = builder;

  try {
    return <Component {...schema.validateSync(content)} />;
  } catch (err) {
    return <BuildPropsError error={err} component={content.component} />;
  }
};

export const CMSBlok = ({ content }) => {
  return <NullErrorBoundary>{componentToElement(content)}</NullErrorBoundary>;
};

CMSBlok.propTypes = {
  content: PropTypes.object.isRequired,
};
